import { render } from "./AnalyticsRoot.vue?vue&type=template&id=fb982aa8"
import script from "./AnalyticsRoot.vue?vue&type=script&lang=js"
export * from "./AnalyticsRoot.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__